<!--  -->
<template>
  <div>
    <div class="choose_palte">
      <div class="chasew">选择平台：</div>
      <div>
        <el-select
          v-model="platform"
          class="launch"
          filterable
          placeholder="选择平台"
          :disabled="onetype === 2"
          @change="chosers"
        >
          <el-option
            v-for="item in platforms"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </div>
    </div>
    <div class="choose_palte">
      <div class="chasew">公众号：</div>
      <div>
        <el-tag v-if="appid" class="chosewaccount">{{ appname }}</el-tag>
        <el-button type="primary" size="mini" :disabled="platform ===null || onetype === 2" @click="chooseappid">选择公众号</el-button>
      </div>
    </div>
    <div class="choose_palte">
      <div class="chasew">选择书籍：</div>
      <div>
        <el-tag v-if="bookid" class="chosewaccount">{{ bookname }}</el-tag>
        <el-button type="primary" size="mini" :disabled="platform ===null || onetype === 2" @click="choosebookid">选择书籍</el-button>
      </div>
    </div>
    <div class="choose_palte">
      <div class="chasew">标题：</div>
      <div>
        <el-input v-model="title" placeholder="请输入标题" style="width:200px" />
      </div>
    </div>
    <div class="choose_palte">
      <div class="chasew">
        封面：
      </div>
      <div v-loading="loading" :class="[updatapath ? '' : 'wrwaw']">
        <div :class="[updatapath ? '' : 'updatabocwr']" @click="$refs.file.click()">
          <input ref="file" style="display:none;" type="file" multiple accept="image/gif,image/jpg,image/jpeg,image/png" @change="uploadPictures">
          <img v-if="updatapath" :src="updatapath" class="updata_casr">
          <i v-else class="el-icon-upload" />
        </div>
      </div>
    </div>
    <div class="choose_palte">
      <div class="chasew">书籍链接：</div>
      <div>
        <el-input v-model="bookUrl" placeholder="请输入链接" style="width:200px" />
      </div>
    </div>
    <el-button type="primary" class="savebox" :disabled="disabledsave" @click="saveclick">保存</el-button>

    <el-dialog
      title="选择公众号"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
    >
      <chooseaccount ref="chooseview" @callback="callback" />
    </el-dialog>
    <el-dialog
      title="选择书籍"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="dialogVisibler"
    >
      <chooseaccountr ref="chooseviewr" @callback="callbackr" />
    </el-dialog>
  </div>
</template>

<script>
import { qiniuToken } from '@/api/qiniuToken.js'
import * as qiniu from 'qiniu-js'
import { newMaterial } from '@/api/sourceMaterial.js'
import chooseaccount from './chooseaccount.vue'
import chooseaccountr from '../../addsubset/components/chooseaccount.vue'
import { strategyPlatform, creatcover, updatacover } from '@/api/sourceMaterial.js'
import getNowDate from '@/utils/mixins/convertToHump.js'
export default {
  components: {
    chooseaccount,
    chooseaccountr
  },
  mixins: [getNowDate],
  data() {
    return {
      platform: null, // 平台
      loading: false,
      appname: '', // appid显示的名字
      appid: null, // appid
      title: '', // 标题
      updatapath: null, // 图片上传地址
      updataid: null, // 图片上传id
      platforms: [], // 平台数组
      token: null,
      dialogVisible: false,
      onetype: null, // 编辑还是新增 1 新增 2 编辑
      bookUrl: '', // 书籍链接

      bookid: null, // 书籍id
      bookname: '', // 书籍名称
      dialogVisibler: false, // 书籍弹窗

      ids: null,
      disabledsave: false
    }
  },
  created() {
    this.getQiniuToken()
  },
  mounted() {

  },
  methods: {
    // 获取七牛云token
    async getQiniuToken() {
      const data = await qiniuToken()
      this.token = data.data.upToken
    },
    // 上传图片
    async uploadPictures(e) {
      console.log('取消', e)

      const fileIfon = e.target.files[0]
      const img = new Image()
      // const temporary = window.URL.createObjectURL(fileIfon)
      // img.src = temporary
      // this.temporary = temporary
      const ftype = fileIfon.name.substr(fileIfon.name.lastIndexOf('.')) // 截取文件格式
      const extension = ftype === '.jpg'
      const extension2 = ftype === '.png'
      const extension3 = ftype === '.jpeg'
      const extension4 = ftype === '.gif'
      // eslint-disable-next-line eqeqeq
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: '请上传正确的上传格式(jpg, png, jpeg, gif)',
          type: 'error'
        })
        return
      }
      const observable = qiniu.upload(fileIfon, `user/${Math.random().toString(36).slice(-6) + '-' + this.getNowDate() + ftype}`, this.token, {
        fname: fileIfon.name // 文件名
      }, {
        useCdnDomain: true // cdn域名加速
      })
      observable.subscribe({
        next() { },
        error(err) {
          console.log(err)
        },
        complete: (data) => {
          setTimeout(async() => {
            this.loading = true
            const datas = await newMaterial({
              type: 1,
              height: img.height,
              width: img.width,
              size: fileIfon.size,
              key: data.key
            })
            console.log('datas', datas.data.path)
            this.updatapath = datas.data.path
            this.updataid = datas.data.sourceMaterialId
            this.loading = false
            // await this.getlist()
            this.temporary = null
          }, 100)
        }

      })
    },
    // 选择appid 弹窗 加上传值
    chooseappid() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.chooseview.send(this.platform)
      })
    },
    // 选择appid 回调
    callback(item) {
      this.dialogVisible = false
      console.log('item', item)
      this.appname = item.accountName
      this.appid = item.appId
    },
    // 保存
    async saveclick() {
      if (this.platform === null) {
        this.$message.error('请选择平台')
        return
      }
      if (this.appid === null) {
        this.$message.error('请选择公众号')
        return
      }
      if (this.bookid === null) {
        this.$message.error('请选择书籍')
        return
      }
      if (this.title === '') {
        this.$message.error('请输入标题')
        return
      }
      if (this.updataid === null) {
        this.$message.error('请选择封面')
        return
      }
      if (this.bookUrl === '') {
        this.$message.error('请输入链接')
        return
      }
      this.disabledsave = true
      if (this.onetype === 1) {
        console.log('新增')
        const data = await creatcover({
          platformId: this.platform,
          appId: this.appid,
          title: this.title,
          coverImg: this.updataid,
          bookId: this.bookid,
          bookUrl: this.bookUrl
        })
        this.$message({
          message: '新增成功',
          type: 'success'
        })
        console.log('data', data)
      } else {
        console.log('编辑')
        const data = await updatacover({
          platformId: this.platform,
          appId: this.appid,
          title: this.title,
          coverImg: this.updataid,
          bookId: this.bookid,
          bookUrl: this.bookUrl,
          id: this.ids
        })
        this.$message({
          message: '更新成功',
          type: 'success'
        })
        console.log('data', data)
      }
      this.$emit('close')
      this.disabledsave = false
    },
    // 点击新增图集 判断编辑 还是新增
    send(type, item) {
      this.strategylist()
      console.log('type', type)
      this.onetype = type
      if (type === 1) {
        console.log('新增')
      } else {
        console.log('编辑', item)
        this.platform = item.platformId
        this.title = item.title
        this.updatapath = item.coverImgPath
        this.updataid = item.coverImg
        this.appid = item.appId
        this.appname = item.appIdText
        this.bookname = item.bookName
        this.bookid = item.bookId
        this.bookUrl = item.bookUrl
        this.ids = item.id
      }
    },
    // 获取策略列表
    async strategylist() {
      const data = await strategyPlatform()
      this.platforms = data.data.list
      console.log('data', data)
    },
    // 选择平台
    chosers(val) {
      console.log('val', val)
      this.appname = ''
      this.appid = null
      this.bookname = ''
      this.bookid = null
    },
    // 选择书籍
    choosebookid() {
      this.dialogVisibler = true
      this.$nextTick(() => {
        this.$refs.chooseviewr.send(this.platform)
      })
    },
    callbackr(item) {
      console.log('item 选择完书籍的回调', item)
      this.bookname = item.book_title
      this.bookid = item.book_id
      this.dialogVisibler = false
      // 选择完书籍的回调
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.choose_palte{
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.chasew{
  width: 80px;
  text-align: right;
}
.updatabocwr{
background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    width: 130px;
    height: 130px;
    cursor: pointer;
    line-height: 146px;
    vertical-align: top;
    text-align: center;

}
.updatabocwr i {
      font-size: 28px;
    color: #8c939d;
}
.updatabocwr i:hover {
    border: none;
}
.wrwaw :hover{
  border: 1px dashed #409eff;
}
.updata_casr{
    width: 130px;
    height: 130px;
}
.savebox{
  margin-left: 10px;
}
.chosewaccount{
  margin-right: 10px;
}
</style>
